import { observer } from 'mobx-react-lite';

import { ShareLinkItem } from './share-link-item';
import { PagePlaceholder } from '../../../components/page-placeholder/page-placeholder';
import { ListViewHeader } from '../../../components/list-view/list-view';
import { SortableHeaderCell } from '../../../components/ordered-list/sortable-header-cell';
import { useOrderBy } from '../../../components/ordered-list/use-order-by';
import { useCurrentProject } from '../../../hooks/use-current-project';

import styles from './share-link-list.module.scss';
export const ShareLinkList = observer(() => {
  const project = useCurrentProject()!;
  const { orderBy, toggleOrder, sort } = useOrderBy();

  if (project.shareLinks.length === 0) {
    return (
      <PagePlaceholder
        title="No files or links shared yet."
        description="You can share multiple items for viewing, commenting or downloading from inside the file's step."
      />
    );
  }

  const shareLinks = sort(project.shareLinks);

  return (
    <table className={styles['table']}>
      <ListViewHeader>
        <SortableHeaderCell
          className={styles['sortable-cell']}
          sortKey="name"
          orderBy={orderBy}
          onOrder={toggleOrder}
        >
          Name
        </SortableHeaderCell>
        <SortableHeaderCell
          className={styles['sortable-cell']}
          sortKey="createdAt"
          orderBy={orderBy}
          onOrder={toggleOrder}
        >
          Creation date
        </SortableHeaderCell>
        <th className={styles['header-cell']}>Number of items</th>
        <th className={styles['header-cell']}>Creator</th>
        <th className={styles['header-cell']}>Allow download</th>
        <th className={styles['header-cell']} />
      </ListViewHeader>

      <tbody>
        {shareLinks.map((link) => (
          <ShareLinkItem key={link._id} link={link} />
        ))}
      </tbody>
    </table>
  );
});
